import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOption } from "../../types";
import { FormPostComment } from "./FormPostComment";
import type { HistoryDetailViewCommentProps } from "./HistoryDetailViewComment";
import { HistoryDetailViewComment } from "./HistoryDetailViewComment";
import { useIsAiAutomationsEnabled } from "./useIsAiAutomationsEnabled";

export const postComment: Readonly<
  ActionOption<HistoryDetailViewCommentProps>
> = {
  label: t("settings.workflows.form.actions.ai_agents_post_comment"),
  textLabel: t("settings.workflows.form.actions.ai_agents_post_comment"),
  value: "ai_agents_post_comment",
  group: t("settings.workflows.form.action_groups.ai_agents"),
  leftAddon: <Icon type="16-ai-action" size={16} className="!h-4 !w-4" />,
  formComponent: FormPostComment,
  viewComponent: null,
  historyDetailViewComponent: HistoryDetailViewComment,
  icon: "chat",
  isApplicableToMembersOnly: false,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.HIGHER_TIER_PLAN_ONLY,
  released: useIsAiAutomationsEnabled,
} as const;
